module.exports = __webpack_public_path__ + "img/pasqualebruni.2ab01977.jpg";